export const TITLE_MAX_LENGTH = 250
export const TITLE_MIN_LENGTH = 10 
export const DESCRIPTION_MAX_LENGTH = 5000
export const THEMES_ON_PAGE = 5
export const SHOW_COUNT_PAGES_IN_PAGINATION = 2
export const COMMENTS_ON_PAGE = 10
export const WIDGET_LAST_COMMENTS_COUNT = 5
export const HEIGH_FROM_TOP_TO_MYDIV = 190
export const COMMENT_LENGTH_FOR_CUT = 415
